"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigitalProxyServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const axios_1 = __importDefault(require("axios"));
class DigitalProxyService extends client_1.RWSService {
    constructor() {
        super(...arguments);
        this.pubKey = '';
    }
    async proxyRequest(url, payload, method = 'POST') {
        try {
            if (process.env.DEV === '1' && !this.pubKey) {
                this.pubKey = process.env.TEST_PUB_KEY || '';
            }
            const response = await axios_1.default.request({
                method: 'POST',
                url: DigitalProxyService.ENDPOINT_URL,
                data: {
                    payload,
                    route: url,
                    pubKey: this.pubKey,
                    method
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        }
        catch (error) {
            console.error('Error in SocialMediaProxyService proxyRequest:', error);
            throw error;
        }
    }
    /**
     * Multipart variant of the proxy request for backend routes that
     * expect an uploaded file (e.g. social-media-post.upload-image).
     * Sends: route, pubKey, payload (JSON string) + single "file" part.
     */
    async proxyUploadRequest(url, file, payload, onProgress) {
        try {
            if (process.env.DEV === '1' && !this.pubKey) {
                this.pubKey = process.env.TEST_PUB_KEY || '';
            }
            const formData = new FormData();
            formData.append('route', url);
            formData.append('pubKey', this.pubKey);
            formData.append('method', 'POST');
            if (payload !== undefined && payload !== null) {
                formData.append('payload', JSON.stringify(payload));
            }
            formData.append('file', file);
            const response = await axios_1.default.request({
                method: 'POST',
                url: DigitalProxyService.UPLOAD_ENDPOINT_URL,
                data: formData,
                onUploadProgress: (progressEvent) => {
                    if (onProgress && progressEvent.total) {
                        onProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    }
                }
            });
            return response.data;
        }
        catch (error) {
            console.error('Error in SocialMediaProxyService proxyUploadRequest:', error);
            throw error;
        }
    }
    setPubKey(pubKey) {
        this.pubKey = pubKey;
    }
    getPubKey() {
        return this.pubKey;
    }
}
exports.DigitalProxyServiceInstance = DigitalProxyService;
DigitalProxyService.ENDPOINT_URL = process.env.BACKEND_URL + `/api/digital-worker/proxy`;
DigitalProxyService.UPLOAD_ENDPOINT_URL = process.env.BACKEND_URL + `/api/digital-worker/proxy-upload`;
exports.default = DigitalProxyService.getSingleton();
